import styled from 'styled-components';
import type { AvatarSizes } from '@frameio/vapor';
import { Separator, theme } from '@frameio/vapor';
import { ProjectHeaderContent } from './ProjectHeaderContent';

export type ProjectHeaderStaticProps = {
  avatarSize?: AvatarSizes;
  avatarUrl: string;
  details: string;
  isPrivate?: boolean;
  projectId: string;
  projectName: string;
};

export function ProjectHeaderStatic({
  avatarSize,
  avatarUrl,
  details,
  isPrivate,
  projectId,
  projectName,
}: ProjectHeaderStaticProps) {
  return (
    <>
      <Container data-testid="project-header-static">
        <ProjectHeaderContent
          avatarSize={avatarSize}
          avatarUrl={avatarUrl}
          details={details}
          isPrivate={isPrivate}
          projectId={projectId}
          projectName={projectName}
        />
      </Container>
      <SeparatorContainer>
        <Separator color="primary" />
      </SeparatorContainer>
    </>
  );
}

const HEADER_HEIGHT = 64;

const Container = styled.div`
  align-items: center;
  cursor: default;
  display: flex;
  height: ${theme.spaces[HEADER_HEIGHT]};
  padding-left: ${theme.spaces[16]};
  padding-right: ${theme.spaces[12]};
  width: 100%;
`;

const SeparatorContainer = styled.div`
  margin-top: -1px;
`;
